import React from 'react';
import { Loader2Icon } from 'lucide-react';
interface ExportingIndicatorProps {
  label: string;
}
export function ExportingIndicator({
  label
}: ExportingIndicatorProps) {
  return <div className="pointer-events-none fixed bottom-6 left-1/2 z-50 -translate-x-1/2" data-id="element-16" data-mp="2jvk2i86yeu6r">
      <p role="status" className="inline-flex items-center gap-2 rounded-lg bg-brand-900 px-4 py-2.5 text-sm font-semibold text-white shadow-lg" data-id="element-17" data-mp="2oudj49hjf1b5">
        <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-18" data-mp="2atavhsaw9iy4" />
        Generating {label} PDF…
      </p>
    </div>;
}